import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MatDialogModule } from '@angular/material';
import { HttpClientModule } from '@angular/common/http';
import { APP_BASE_HREF, LocationStrategy, HashLocationStrategy } from '@angular/common';

import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';
import { MainNavComponent } from './navigation/main-nav/main-nav.component';
import { HomeComponent } from './home/home.component';
import { MenuAnimationDirective } from './_directives/menu-animation.directive';
import { NavProgressComponent } from './navigation/nav-progress/nav-progress.component';
import { CarouselComponent } from './shared/carousel/carousel.component';
import { SectionTransitionComponent } from './shared/section-transition/section-transition.component';

import * as Hammer from 'hammerjs';
import { HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { SecondaryNavComponent } from './navigation/secondary-nav/secondary-nav.component';
import { SpaceIntroComponent } from './sections/space/space-intro/space-intro.component';
import { SpaceCarouselComponent } from './sections/space/space-carousel/space-carousel.component';
import { SkyIntroComponent } from './sections/sky/sky-intro/sky-intro.component';
import { SkyCarouselComponent } from './sections/sky/sky-carousel/sky-carousel.component';
import { SeaIntroComponent } from './sections/sea/sea-intro/sea-intro.component';
import { SeaCarouselComponent } from './sections/sea/sea-carousel/sea-carousel.component';
import { CityIntroComponent } from './sections/city/city-intro/city-intro.component';
import { CityCarouselComponent } from './sections/city/city-carousel/city-carousel.component';

import { PreviousRouteService } from './_services/previous-route.service';
import { StoryModalComponent } from './shared/story-modal/story-modal.component';
import { TimelineThumbDirective } from './_directives/timeline-thumb.directive';
import { ArModalComponent } from './shared/ar-modal/ar-modal.component';
import { LoopBeginningVideoDirective } from './_directives/loop-beginning-video.directive';
import { ToggleArticleDirective } from './_directives/toggle-article.directive';

export class MyHammerConfig extends HammerGestureConfig  {
  overrides = <any>{
      // override hammerjs default configuration
      'swipe': { direction: Hammer.DIRECTION_ALL  },
      'pan': { direction: Hammer.DIRECTION_ALL  }
  }
}



@NgModule({
  declarations: [
    AppComponent,
    MainNavComponent,
    HomeComponent,
    MenuAnimationDirective,
    NavProgressComponent,
    CarouselComponent,
    SectionTransitionComponent,
    SecondaryNavComponent,
    SpaceIntroComponent,
    SpaceCarouselComponent,
    SkyIntroComponent,
    SkyCarouselComponent,
    SeaIntroComponent,
    SeaCarouselComponent,
    CityIntroComponent,
    CityCarouselComponent,
    StoryModalComponent,
    TimelineThumbDirective,
    ArModalComponent,
    LoopBeginningVideoDirective,
    ToggleArticleDirective
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatDialogModule,
    RouterModule.forRoot(appRoutes,{ useHash: true, scrollPositionRestoration: 'enabled' })
  ],
  providers: [
    PreviousRouteService,
    { provide: APP_BASE_HREF, useValue: '/' },// run locally
    { provide: LocationStrategy, useClass: HashLocationStrategy },// run locally
    {
      provide: HAMMER_GESTURE_CONFIG,  
      useClass: MyHammerConfig 
    }
  ],
  entryComponents: [
    StoryModalComponent,
    ArModalComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
